"use strict";

var LoggerInstance = require("js-logger").get("DonationAmount");
var React = require("react");

var CheckoutActions = require("./CheckoutActions");
var CheckoutStore = require("./CheckoutStore");

var ActionsHelper = require("../actions/ActionsHelper");

var InputHelper = require("../shared/InputHelper");

var DonationAmount = React.createClass({
	propTypes: {
		className: React.PropTypes.string,
		isDesignMode: React.PropTypes.bool,
		cartItemId: React.PropTypes.string,
		showDecimals: React.PropTypes.bool,
		includeCurrencySymbol: React.PropTypes.bool,
		theme: React.PropTypes.string,
		isCustomTheme: React.PropTypes.bool,
		dataComponentId: React.PropTypes.string,
		dataNestedId: React.PropTypes.string,
		dataRepeatedId: React.PropTypes.string
	},

	handleBlur: function () {
		this.setState({ focused: false }, () => {
			if (!this.props.isDesignMode) {
				CheckoutActions.updateDonation(this.props.cartItemId);
			}
		});
	},

	handleFocus: function () {
		this.setState({ focused: true });
	},

	handleAmountChange: function (event) {
		// Enforce that the value can be a number followed by a decimal and up to two digits
		// valid: 8, 8., ., .8, .88
		// invalid: .888, 8.888, asdf, '8,888'
		if (InputHelper.isAmountValid(event.currentTarget.value)) {
			CheckoutActions.setDonationAmount(this.props.cartItemId, ActionsHelper.convertFormattedAmountToNumberString(event.currentTarget.value));
		}
	},

	formatAmountKeepUserDecimals: function (amount) {
		return this._formatAmount(amount, true);
	},

	formatAmount: function (amount) {
		return this._formatAmount(amount, false);
	},

	// If keepDecimals, do not format out the decimals.
	// User entered information should not strip out decimals.
	_formatAmount: function (amount, keepDecimals) {
		return ActionsHelper.formatAmount(amount, this.props.showDecimals, this.props.includeCurrencySymbol, keepDecimals);
	},

	getStateFromStore: function () {
		return {
			donationAmount: CheckoutStore.getDonationAmount(this.props.cartItemId)
		};
	},

	_onChange: function () {
		this.setState(this.getStateFromStore());
	},

	componentDidMount: function () {
		if (this.props.isDesignMode) {
			parent.window.ComponentActions.childComponentLoaded(this);
		}
		CheckoutStore.addChangeListener(this._onChange);
	},

	componentWillUnmount: function () {
		CheckoutStore.removeChangeListener(this._onChange);

		if (this.props.isDesignMode) {
			parent.window.ComponentActions.childComponentUnloaded(this);
			CheckoutActions.setDonationAmount(this.props.cartItemId, null);
		}
	},

	getDefaultProps: function () {
		return {
			includeCurrencySymbol: true,
			showDecimals: true
		};
	},

	getInitialState: function () {
		var state = this.getStateFromStore();
		state.focused = false;
		if (this.props.isDesignMode) {
			state.donationAmount = "0";
		}
		return state;
	},

	render: function () {
		var donationAmount = this.state.donationAmount;
		if (!this.state.focused) {
			donationAmount = this.formatAmount(donationAmount);
		} else {
			donationAmount = ActionsHelper.replaceAmountDecimalSymbols(this.state.donationAmount);
		}

		return (
			<span
				data-react-component-name="DonationAmount"
				data-react-component-category="DonationCartItemComponents"
				data-component-id={this.props.dataComponentId}
				data-nested-id={this.props.dataNestedId}
				data-repeated-id={this.props.dataRepeatedId}
				data-theme={+this.props.theme ? this.props.theme : undefined}
				data-custom={this.props.isCustomTheme || null}
				data-child-of={this.props.dataChildOf}
			>
				<input
					type="text"
					value={donationAmount}
					maxLength="10"
					onBlur={this.handleBlur}
					onChange={this.handleAmountChange}
					onFocus={this.handleFocus}
					className={this.props.className}
					data-override-classes={this.props.className}
					inputMode="decimal"
				/>
			</span>
		);
	}
});

module.exports = DonationAmount;



// WEBPACK FOOTER //
// ./Javascript/checkoutComponents/DonationAmount.jsx